module.exports = __webpack_public_path__ + "media/images/money_pig-fe4b3dc1e4cabd0aba1e2bdb84a2e5c0.svg";